module.exports = __webpack_public_path__ + "static/img/man-woman.433a499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/man-woman.png
// module id = 919
// module chunks = 1